<template>
  <div class="e-image-loaded-card" :class="{ 'cursor-auto': file.error || file.loading, loading: file.loading }">
    <v-img
      class="e-image-loaded-card__img"
      cover
      :class="{ 'e-image-loaded-card__img_error': file.error }"
      :src="file.url"
      @click="onImageClick"
    />

    <e-btn
      v-if="deleteable"
      class="e-image-loaded-card__delete"
      icon
      size="S"
      variant="tonal"
      :loading="file.loading"
      @click="onDeleteClick"
    >
      <e-icon name="trash" :size="20" />
    </e-btn>

    <div v-if="file.error" class="e-image-loaded-card__error paragraph-xxs">
      <e-icon name="alertFull" :size="14" class="text-red mr-2 mt-1" />
      {{ file.error }}
    </div>
  </div>
</template>

<script setup lang="ts">
import type { LoadedFile } from '@/core/types/files';
import { EBtn, EIcon } from '@/core/components/ui';

const props = withDefaults(
  defineProps<{
    file: LoadedFile;
    deleteable?: boolean;
  }>(),
  { deleteable: true },
);

const emit = defineEmits<{
  (event: 'delete'): void;
}>();

const onDeleteClick = () => {
  emit('delete');
};

const onImageClick = () => {
  window.open(props.file.url, '_blank');
};
</script>

<style scoped lang="scss">
$root: e-image-loaded-card;
.#{$root} {
  position: relative;

  overflow: hidden;

  background-color: $bg-light-color;
  border-radius: $border-radius;

  cursor: zoom-in;

  aspect-ratio: 1/1;

  @include hover {
    .#{$root}__delete {
      opacity: 1;
    }
  }

  &.loading {
    .#{$root}__delete {
      opacity: 1;
    }
  }

  &__img {
    width: 100%;
    height: 100%;

    &_error {
      opacity: 0.2;
    }
  }

  &__delete {
    position: absolute;
    top: 8px;
    right: 8px;

    opacity: 0;

    @include md-and-down {
      opacity: 1;
    }
  }

  &__error {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    display: flex;
    justify-content: center;
    align-items: center;

    padding: 8px;

    color: $text-alert-color;
  }
}
</style>
